module.exports = __webpack_public_path__ + "static/img/vedio-bg-1.58bed85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/pc/imgs/vedio-bg-1.png
// module id = 9wL0
// module chunks = 13